import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../frontend/components/Header';
import Footer from '../frontend/components/Footer';

const PlanSelectionPage = () => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState('myself');

  const handleContinue = () => {
    // Redirect based on selected option
    switch(selectedOption) {
      case 'myself':
        navigate('/enrollment/myself');
        break;
      case 'someone':
        navigate('/enrollment/someone-else');
        break;
      case 'family':
        navigate('/enrollment/family-group');
        break;
      default:
        navigate('/enrollment/myself');
    }
  };

  return (
    <div style={styles.container}>
      <Header />
      {/* Main Content */}
      <main style={styles.mainContent}>
         <button 
                onClick={() => navigate(-1)} 
                style={{
                  background: 'transparent',
                  color: '#4b5563',
                  padding: '8px 20px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.3s ease',
                  border: '2px solid #e5e7eb',
                  cursor: 'pointer',
                  fontSize: '0.95rem'
                }}
                onMouseOver={(e) => { 
                  e.currentTarget.style.borderColor = '#F89423'; 
                  e.currentTarget.style.color = '#F89423'; 
                }}
                onMouseOut={(e) => { 
                  e.currentTarget.style.borderColor = '#e5e7eb'; 
                  e.currentTarget.style.color = '#4b5563'; 
                }}
              >
                <i className="fas fa-arrow-left"></i> Go Back 
              </button>
        <h1 style={styles.heading}>Who are you buying this plan for?</h1>
        
        {/* Progress Bar */}
        <div style={styles.progressContainer}>
          <div style={styles.progressBarFill}></div>
          <span style={styles.progressText}>33%</span>
        </div>

        {/* Selection Cards */}
        <div style={styles.cardsContainer}>
          {/* Card 1: Myself */}
          <div 
            style={{...styles.card, ...styles.cardMyself, ...(selectedOption === 'myself' ? styles.cardSelected : {})}}
            onClick={() => setSelectedOption('myself')}
          >
            <div style={styles.iconContainer}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={styles.svgIcon}>
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <h3 style={styles.cardTitle}>Myself</h3>
            <p style={styles.cardDesc}>Purchase health coverage for yourself only</p>
          </div>

          {/* Card 2: Someone Else */}
          <div 
            style={{...styles.card, ...styles.cardSomeone, ...(selectedOption === 'someone' ? styles.cardSelected : {})}}
            onClick={() => setSelectedOption('someone')}
          >
            <div style={styles.iconContainer}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={styles.svgIcon}>
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <h3 style={styles.cardTitle}>Someone Else</h3>
            <p style={styles.cardDesc}>Perfect for gifting coverage to friends, loved ones and groups of people</p>
          </div>

          {/* Card 3: Family/Group */}
          <div 
            style={{...styles.card, ...styles.cardFamily, ...(selectedOption === 'family' ? styles.cardSelected : {})}}
            onClick={() => setSelectedOption('family')}
          >
            <div style={styles.iconContainer}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={styles.svgIcon}>
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                <path d="M21 11v2"></path>
                <path d="M21 15v2"></path>
              </svg>
            </div>
            <h3 style={styles.cardTitle}>Family/Group</h3>
            <p style={styles.cardDesc}>Perfect for covering your spouse, children or employees</p>
          </div>
        </div>

        {/* Continue Button */}
        <button 
          style={styles.continueBtn} 
          onClick={handleContinue}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#ea7c1f'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#F89423'}
        >
          Continue <span style={{marginLeft: '8px'}}>→</span>
        </button>
      </main>

      <Footer />
    </div>
  );
};

const styles = {
  container: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    backgroundColor: '#ffffff',
    minHeight: '100vh',
    color: '#333',
  },
  mainContent: {
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '60px 20px',
  },
  heading: {
    fontSize: '28px',
    fontWeight: '600',
    marginBottom: '30px',
    color: '#111',
    textAlign: 'center'
  },
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '40px',
    position: 'relative',
    height: '8px',
    backgroundColor: '#f3f4f6',
    borderRadius: '4px',
  },
  progressBarFill: {
    width: '33%',
    height: '100%',
    backgroundColor: '#F89423', // Brand orange
    borderRadius: '4px',
    transition: 'width 0.3s ease'
  },
  progressText: {
    position: 'absolute',
    right: '0',
    top: '-25px',
    fontSize: '14px',
    color: '#F89423', // Brand orange
    fontWeight: '600',
  },
  cardsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    marginBottom: '40px',
  },
  card: {
    border: '1px solid #e2e8f0',
    borderRadius: '12px',
    padding: '40px 20px',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '220px',
  },
  cardSelected: {
    border: '2px solid #F89423',
    boxShadow: '0 4px 12px rgba(248, 148, 35, 0.2)',
    backgroundColor: 'rgba(248, 148, 35, 0.12)',
  },
  cardMyself: {
    backgroundColor: 'rgba(248, 148, 35, 0.08)', // Light orange tint
  },
  cardSomeone: {
    backgroundColor: 'rgba(248, 148, 35, 0.08)', // Light orange tint
  },
  cardFamily: {
    backgroundColor: 'rgba(248, 148, 35, 0.08)', // Light orange tint
  },
  iconContainer: {
    marginBottom: '20px',
  },
  svgIcon: {
    width: '48px',
    height: '48px',
    color: '#F89423', // Brand orange
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '10px',
    color: '#111',
  },
  cardDesc: {
    fontSize: '14px',
    color: '#666',
    lineHeight: '1.5',
    margin: 0,
  },
  continueBtn: {
    backgroundColor: '#F89423', // Brand orange
    color: 'white',
    border: 'none',
    padding: '12px 30px',
    borderRadius: '25px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
    transition: 'background-color 0.2s ease',
  },
};

export default PlanSelectionPage;